import React from "react";
// ANT DESIGN COMPONENTS
import { Switch } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../../../redux/reports/reportsSlice";
// COMPONENTS
import ReportsFilterDateRange from "../filters/ReportsFilterDateRange";
import ReportsFilterDateDay from "../filters/ReportsFilterDateDay";
import ReportsFilterDateWeek from "../filters/ReportsFilterDateWeek";
import ReportsFilterDateMonth from "../filters/ReportsFilterDateMonth";
import ReportsFilterDateQuarter from "../filters/ReportsFilterDateQuarter";
import ReportsFilterDateYear from "../filters/ReportsFilterDateYear";
import ReportsFilterDateType from "../filters/ReportsFilterDateType";
import ReportsFilterSelectSeconds from "../filters/ReportsFilterSelectSeconds";
// INTERFACES
import { RootState } from "../../../app/store";
import { ReportSliceFiltersInterface } from "../../../interfaces/Reports.interface";

function ReportsDrawerDateAndTimeFilters() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const dispatch = useDispatch();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);
	const { filters } = useSelector((state: RootState) => state.report);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeDateRange = (e: boolean) => {
		const copy: ReportSliceFiltersInterface = structuredClone(filters);
		copy.displayDateByRange = e;
		dispatch(updateFilters(copy));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className={`drawer__box__${theme}`}>
			{/* DATE BY RANGE */}
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span className='drawer__title'>{t("general.dateByRange")}:</span>
				</div>
				<div className='drawer__textContainer generalStyles__width100'>
					<Switch
						onChange={(e) => {
							onChangeDateRange(e);
						}}
						checked={filters.displayDateByRange}
					/>
				</div>
			</div>
			{/* START DATE */}
			<div className='generalStyles__flex mt-3'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span className='drawer__title'>{t("general.date")}:</span>
				</div>
				<div className='drawer__textContainer generalStyles__width100'>
					{filters.displayDateByRange ? (
						<ReportsFilterDateRange />
					) : (
						<>
							{filters.dateType === "TODAY" && <ReportsFilterDateDay />}
							{filters.dateType === "WEEK" && <ReportsFilterDateWeek />}
							{filters.dateType === "MONTH" && <ReportsFilterDateMonth />}
							{filters.dateType === "QUARTER" && <ReportsFilterDateQuarter />}
							{filters.dateType === "YEAR" && <ReportsFilterDateYear />}
						</>
					)}
				</div>
			</div>
			{/* SELECT */}
			<div className='generalStyles__flex mt-3'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span className='drawer__title'>{t("general.dateType")}:</span>
				</div>
				<div className='drawer__textContainer generalStyles__width100'>
					<ReportsFilterDateType />
				</div>
			</div>
			{/* TIME IN SECONDS */}
			{filters.displayMinimumActivation && (
				<div className='generalStyles__flex mt-3'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__title'>Minimum Activation:</span>
					</div>
					<div className='drawer__textContainer generalStyles__width100'>
						<ReportsFilterSelectSeconds />
					</div>
				</div>
			)}
		</div>
	);
}

export default ReportsDrawerDateAndTimeFilters;
